import React, { useEffect } from 'react';
import { navigate } from '@reach/router';

const StatusPageCustomization = props => {
  const { user } = props;
  useEffect(() => {
    if (user && user.role === 'ED') {
      navigate(`/admin/incidents/public`);
    }
  }, [user]);
  return <>{props.children}</>;
};

export default StatusPageCustomization;
